import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { NotificationsFacade } from "@modules/notifications/domain/+state/notifications.facade";

@Component({
	selector: "notifications-board",
	templateUrl: "./notifications-board.component.html",
	styleUrls: ["./notifications-board.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NotificationsBoardComponent implements OnInit {
	public ngOnInit(): void {
		this.notificationsFacade.initList();
	}

	@Output() public onCloseClick = new EventEmitter<void>();

	public constructor(private readonly notificationsFacade: NotificationsFacade) {}

	public onCloseNotifications(): void {
		this.onCloseClick.emit();
		this.notificationsFacade.rudderstackTracking("Notification Centre Close Icon Clicked");
	}
}
